var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    height: "24px",
    id: "Layer_1",
    viewBox: "0 0 32 32",
    width: "24px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M16,27c-0.23,0-0.461-0.079-0.648-0.238c-0.242-0.206-5.942-5.1-8.32-10.438c-0.225-0.504,0.002-1.096,0.507-1.32    c0.503-0.224,1.095,0.002,1.32,0.507c1.739,3.905,5.577,7.699,7.124,9.13C18.713,21.991,24,16.069,24,12.23    C24,7.692,20.411,4,16,4s-8,3.692-8,8.23c0,0.552-0.448,1-1,1s-1-0.448-1-1C6,6.589,10.486,2,16,2c5.514,0,10,4.589,10,10.23    c0,5.912-8.944,14.159-9.325,14.508C16.484,26.912,16.242,27,16,27z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M16,16c-2.206,0-4-1.794-4-4s1.794-4,4-4c2.206,0,4,1.794,4,4S18.206,16,16,16z M16,10c-1.103,0-2,0.897-2,2s0.897,2,2,2    c1.103,0,2-0.897,2-2S17.103,10,16,10z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M29,30H3c-0.356,0-0.686-0.189-0.865-0.498c-0.179-0.309-0.18-0.688-0.003-0.998l4-7c0.274-0.479,0.885-0.647,1.364-0.372    c0.479,0.274,0.646,0.885,0.372,1.364L4.723,28h22.553l-3.145-5.504c-0.274-0.479-0.107-1.09,0.372-1.364    c0.479-0.276,1.09-0.107,1.364,0.372l4,7c0.177,0.31,0.176,0.689-0.003,0.998C29.686,29.811,29.356,30,29,30z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/mapIcon.11e8755e9c82a7676ac3df3ff07ee2f8.svg";
export { ForwardRef as ReactComponent };